import React from 'react';

// Place inside a <dl>. The icon is a node so callers can use any icon set.
export default function InfoFact({ icon, label, children, plain = false }) {
  return (
    <div className={`relative min-h-[40px] ${plain ? '' : 'pl-[52px]'}`}>
      <dt className="text-sm text-krit-muted">
        {!plain && <span aria-hidden="true" className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-xl bg-krit-paper">{icon}</span>}
        {label}
      </dt>
      <dd className="mt-1 text-base font-semibold leading-relaxed">{children}</dd>
    </div>
  );
}
